export function showNotification(message, type = 'success', time = 2000) {
    let container = document.getElementById('notification-container');

    // Cria o contêiner se não existir
    if (!container) {
        container = document.createElement('div');
        container.id = 'notification-container';
        container.className = 'notification-container';
        document.body.appendChild(container);
    }

    // Cria o elemento da notificação
    const notification = document.createElement('div');
    notification.className = `notification ${type}`;
    notification.textContent = message;

    // Adiciona a notificação ao contêiner
    container.appendChild(notification);

    // // Remove a notificação após 5 segundos
    setTimeout(() => { container.removeChild(notification); }, time);
}